
import React, { useRef, useEffect, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import 'mapbox-gl/dist/mapbox-gl.css';
import { Region } from '../../../data/types/region-types';
import { Church } from './types';
import { useLanguage } from '../../../contexts/language';
import ChurchMarkers from './components/ChurchMarkers';
import ResetViewButton from './components/ResetViewButton';
import { useChurchesMap } from './hooks/use-churches-map';

interface ChurchesMapProps {
  region: Region;
  churches: Church[];
  selectedChurch: Church | null;
  onChurchSelect: (church: Church) => void;
  onResetView: () => void;
}

const ChurchesMap: React.FC<ChurchesMapProps> = ({ 
  region, 
  churches, 
  selectedChurch, 
  onChurchSelect,
  onResetView 
}) => {
  const { map, mapContainer } = useChurchesMap(region);
  const [mapReady, setMapReady] = useState(false);
  
  useEffect(() => {
    if (map.current) {
      map.current.once('load', () => {
        setMapReady(true);
      });
    }
  }, [map.current]);
  
  return (
    <div className="h-56 rounded-xl overflow-hidden mb-4 relative shadow-inner border border-gray-100">
      <div ref={mapContainer} className="w-full h-full" />
      {map.current && mapReady && (
        <>
          <ChurchMarkers 
            map={map.current}
            churches={churches}
            selectedChurch={selectedChurch}
            onChurchSelect={onChurchSelect}
          />
          <ResetViewButton onClick={onResetView} />
        </>
      )}
    </div>
  );
};

export default ChurchesMap;
